import Vue from "vue";

export async function update(payload, id) {
  const response = await Vue.prototype.$http.put("/services/" + id, payload);

  return response.data;
}
